import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [MatButtonModule, CommonModule, MatTooltipModule],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent {
  @Input() variant:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'quaternary'
    | 'quinary'
    | 'danger-tertiary'
    | 'danger' = 'primary';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() isDisabled: boolean = false;
  @Output() buttonClick = new EventEmitter<Event>();
  @Input() title: string = '';
  @Input() tooltip: string = ''; // Tooltip text
  @Input() ariaLabel: string = 'Button'; // ARIA label for accessibility
  @Input() tooltipPosition: 'above' | 'below' | 'left' | 'right' = 'below'; // Tooltip position
  @Input() tooltipClass: string = '';

  get buttonClass(): string {
    return `mat-${this.variant}-button`;
  }

  get buttonStyle() {
    return this.isDisabled ? { cursor: 'not-allowed', opacity: '0.7' } : {};
  }

  onClick(event: Event) {
    if (!this.isDisabled) {
      this.buttonClick.emit(event);
    }
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onClick(event);
    }
  }
}
